module["exports"] = [
  "straat",
  "laan",
  "weg",
  "plantsoen",
  "park"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/street_suffix.js
// module id = 1906
// module chunks = 0